// Event Types
export const SEE_ALL = 'See All';
export const AUDIO_WAVEFORM = 'Audio Waveform';
